// extracted by css-extract-rspack-plugin
export default {"root":"kPk9Q0bqcbIaE_Bm","wrapper":"IOg33OBcEKIMBGyT","header":"hgLbyI8aL_Q_DOsb","section":"XaIkOZWZQ58D4jAf","divider":"QKJsgtRJP7cngVnp"};